export default "__VITE_ASSET__Csbmlujn__"